import { Component, Prop, Vue } from 'vue-property-decorator'

import Loader from '@/components/Loader/index.vue'
import CircularProgress from '@/components/CircularProgress/index.vue'

import vSelect from 'vue-select'
import QrScanner from 'qr-scanner'

import api from '@/helpers/fetch'
import tableHelper from '@/helpers/table'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPen, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { faCopy } from '@fortawesome/free-regular-svg-icons'

library.add(faPen, faTrashAlt, faCopy)
@Component({
	components: {
		vSelect,
		CircularProgress,
		Loader,
	},
})
export default class RatingDeadlines extends Vue {
	progress = 0
	intervalCircularProgress = 0
	timeLeft = 0
	qrScanner = null as any
	siteToDelete = null as any
	loadingScanner = true
	loadingTable = true
	sendingEditForm = false

	form = {
		id: '',
		desc: '',
		site: '',
	}

	fields = [
		{
			key: 'index',
			label: '#',
			tdClass: 'table-2fa-cell text-center',
			thClass: 'table-2fa-header-index',
		},
		{ key: 'actions', label: 'Ações', thStyle: 'width: 5%' },
		{ key: 'desc', label: 'Descrição', tdClass: 'table-2fa-cell' },
		{ key: 'provider', label: 'Origem', tdClass: 'table-2fa-cell' },
		{ key: 'lawyer', label: 'Advogado', tdClass: 'table-2fa-cell' },
		{ key: 'code', label: 'Código', tdClass: 'table-2fa-cell' },
	]

	items = []

	async mounted() {
		await this.loadCodes()

		this.intervalCircularProgress = setInterval(() => {
			const timeUsed = Math.floor(new Date().getTime() / 1000) % 30
			this.timeLeft = 30 - timeUsed
			this.progress = timeUsed * 3.33
			if (timeUsed === 1) {
				this.loadCodes()
			}
		}, 1000) as any
	}

	startScan() {
		this.qrScanner = new QrScanner(
			this.$refs.scanner as HTMLVideoElement,
			(result) => this.submitURIOTP(result.data),
			{
				highlightScanRegion: true,
				returnDetailedScanResult: true,
			},
		)
		this.qrScanner.start().then(() => {
			this.loadingScanner = false
		})
	}

	scanCleanup() {
		this.qrScanner.destroy()
		this.qrScanner = null
		this.loadingScanner = true
	}

	async submitURIOTP(keyuri) {
		this.loadingScanner = true
		this.qrScanner.stop()
		const res = await api.post('/api/otp-app/sites/', {
			keyuri,
		})

		if (res.ok) {
			this.loadCodes()
			this.$bvModal.hide('qr-scanner')
		}
	}

	setEditForm(site) {
		this.form.id = site.id
		this.form.desc = site.desc
	}

	resetForm() {
		this.form.id = ''
		this.form.desc = ''
		this.form.site = ''
	}

	async sendEditForm() {
		this.sendingEditForm = true
		const res = await api.post('/api/otp-app/sites/' + this.form.id, {
			desc: this.form.desc,
		})
		this.sendingEditForm = false

		if (res.ok) {
			this.loadCodes()
			this.$bvModal.hide('edit-form')
		}
	}

	onDelete(site) {
		this.siteToDelete = site
		this.$bvModal.show('modal-delete')
	}

	deleting = false
	deleteSuccess = false
	async onDeleteConfirm() {
		this.deleting = true
		if (this.siteToDelete) {
			this.deleteSuccess = false
			const res = await api.delete(
				'/api/otp-app/sites/' + this.siteToDelete.id,
			)

			if (res.ok) {
				this.deleteSuccess = true
				this.loadCodes()
				this.$bvModal.hide('modal-delete')
			}
		}
		this.deleting = false
	}

	async loadCodes() {
		this.loadingTable = true
		const res = await api.get('/api/otp-app/sites')
		this.loadingTable = false
		if (res.ok) {
			this.items = res.data
		}
	}

	copy(code) {
		navigator.clipboard.writeText(code)
		this.$bvToast.toast('Código Copiado!', {
			title: 'Código Copiado!',
			variant: 'success',
			solid: true,
			toaster: 'b-toaster-top-center',
		})
	}

	beforeDestroy() {
		clearInterval(this.intervalCircularProgress)
	}
}
